import React, { useState } from 'react';
import { Button, Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
	EnvelopeOpen,
	House,
} from 'react-bootstrap-icons';
import ModalAcervo from './ModalAcervo';
import Fototeca from '../images/acervos/img-home-fototeca.jpg';
import Archivo from '../images/acervos/img-home-ah.jpg';
import CollectionButtons from './CollectionButtons';
const infoAcervos = [
	{
		title: 'Fototeca Guatemala',
		description: (
			<>
				<p>
					La Fototeca Guatemala, creada en 1979, al principio
					inspirada por el trabajo de Mitchell Denburg, representa el
					esfuerzo más significativo para rescatar la memoria visual
					de Guatemala.
				</p>
				<p>
					Sus colecciones retratan los diferentes grupos étnicos,
					sociales y políticos desde 1850 hasta el presente y proveen
					un rico registro de la evolución histórica del país. Además,
					plasman las tradiciones culturales, la vida cotidiana, el
					arte, la arquitectura, los hechos políticos y los desastres
					naturales de los últimos ciento cincuenta años. Hoy en día
					cuenta con 220 colecciones que suman más de un millón de
					fotografías en formatos que van desde daguerrotipos y
					negativos en placas de vidrio hasta imágenes digitales.
				</p>
				<p>
					El enfoque principal de la Fototeca Guatemala consiste en
					resguardar, sistematizar, organizar, digitalizar y poner a
					disposición del público los contenidos de las colecciones,
					así como difundir las buenas prácticas de conservación y
					manejo de colecciones fotográficas a todos los
					guatemaltecos.
				</p>
			</>
		),
		image: Fototeca,
	},
	{
		title: 'Archivo Histórico',
		description: (
			<>
				<p>
					Fundado en el año 1997 por la antropóloga Tani Adams, el
					Archivo Histórico tiene como propósito principal resguardar
					parte de la memoria histórica del país a través del rescate,
					organización, conservación y difusión de archivos
					documentales.
				</p>
				<p>
					Los materiales provienen de instituciones no gubernamentales
					y colecciones particulares y se presentan en diferentes
					formatos (papel, digital, microfilm, audio y video). Estos
					archivos, algunos únicos y otros poco conocidos, enriquecen
					el legado histórico nacional y ofrecen diferentes puntos de
					vista de la sociedad guatemalteca a lo largo del tiempo.
				</p>
				<p>
					Sus colecciones, algunas reconocidas como patrimonio
					cultural de la nación, datan del siglo XVI a la actualidad,
					haciendo énfasis en la época contemporánea a partir de 1944.
					Actualmente alberga 166 colecciones integradas por más de
					once millones de documentos, así como una importante
					colección de mapas antiguos.
				</p>
			</>
		),
		image: Archivo,
	},
];
export default function HeaderSection(props) {
	const {
		title,
		subtitle,
		button,
		collection,
		isad,
		apiService,
		setShowMetadata,
		showMetadata,
	} = props;
	const [show, setShow] = useState(false);
	const handleShow = () => setShow(true);
	return (
		<div className='c-top-header-section'>
			<Container>
				{!button && !collection && (
					<div className='c-top-header-containerr'>
						<div className='c-top-header-title'>
							<h1>{title}</h1>
						</div>
						<div className='c-top-btns'>
							<CollectionButtons
								apiService={apiService}
								setShowMetadata={setShowMetadata}
								showMetadata={showMetadata}
							/>
						</div>
						<div className='c-divisor'>
							<div className='c-line'></div>
						</div>
						{subtitle && (
							<ul>
								<li key={0}>
									<Link
										to={`${process.env.PUBLIC_URL}/agency/${
											subtitle === 'Fototeca Guatemala'
												? 'GT-CIRMA-FG'
												: 'GT-CIRMA-AH'
										}`}
									>
										<House />
									</Link>
								</li>
								<li key={1}>
									<Link
										to={`${process.env.PUBLIC_URL}/agency/${
											subtitle === 'Fototeca Guatemala'
												? 'GT-CIRMA-FG'
												: 'GT-CIRMA-AH'
										}`}
									>
										{subtitle}
									</Link>
								</li>
								<li key={2}>
									<Link
										to={
											process.env.PUBLIC_URL +
											'/collection/' +
											isad.father.id +
											'?nav=' +
											isad.father.id
										}
									>
										{isad.father.title}
									</Link>
								</li>
							</ul>
						)}
						{/* <ModalCollection
							show={showCol}
							setShow={setShowCol}
							apiService={apiService}
						/> */}
					</div>
				)}
				{!button && collection && (
					<div className='c-top-header-section-collection'>
						<div className='c-top-header-container'>
							{/* <div className='c-top-header-'> */}
							<div>
								<div className='c-top-header-title'>
									<h1 onClick={handleShow}>{title}</h1>
								</div>
								<div className='c-divisor'>
									<div className='c-line'></div>
								</div>
							</div>
							<div className='c-top-header-collection-buttons'>
								<Button
									onClick={handleShow}
									className='c-see-more'
								>
									CONOZCA MAS DE {title}
								</Button>
								<OverlayTrigger
									placement={'top'}
									overlay={
										<Tooltip id={`tooltip-top`}>
											Contactarse con el{' '}
											{title === 'Fototeca Guatemala'
												? ' FG'
												: ' AH'}
										</Tooltip>
									}
								>
									<a
										href={`/contactenos?acervo=${
											title === 'Fototeca Guatemala'
												? 'fototeca'
												: 'archivo'
										}`}
										className='c-contact'
									>
										<EnvelopeOpen />
									</a>
								</OverlayTrigger>
							</div>
							{/* </div> */}
						</div>
						{title === 'Fototeca Guatemala' ? (
							<ModalAcervo
								title={title}
								description={infoAcervos[0].description}
								show={show}
								setShow={setShow}
								image={infoAcervos[0].image}
							/>
						) : (
							<ModalAcervo
								title={title}
								description={infoAcervos[1].description}
								show={show}
								setShow={setShow}
								image={infoAcervos[1].image}
							/>
						)}
					</div>
				)}
			</Container>
		</div>
	);
}
